import { LOGIN_SUCCESS, LOGIN_ERROR, SIGN_OUT, SIGN_UP, SIGN_UP_ERROR, RESET_PASSWORD, RESET_PASSWORD_ERROR, NEW_PASSWORD, NEW_PASSWORD_ERROR, ADD_TRAINER, ADD_TRAINER_ERROR } from '../../Actions/actionTypes'

export const signIn = (credentials) => {

    return(dispatch, getState, { getFirebase}) => {
        const firebase = getFirebase();
        firebase.auth().signInWithEmailAndPassword(
            credentials.email,
            credentials.password
        ).then(() => {
            dispatch({ type: LOGIN_SUCCESS})
        }).catch((err) => {
            dispatch({ type: LOGIN_ERROR, err})
        })
    }
}

export const signOut = () => {
    return(dispatch, getState, {getFirebase}) =>{
        const firebase = getFirebase();
        firebase.auth().signOut().then(()=>
            dispatch({ type: SIGN_OUT})
        )
    }
}


export const signUp = (newUser) => {

    var companyName = newUser.company.replace(/[^A-Z0-9]+/ig, "-")
    var companySlugFromName = companyName.toLowerCase()
    var userId = null
    var companyIdFromName = null
    return(dispatch, getState, {getFirebase, getFirestore}) => {
        const firebase = getFirebase();
        const firestore = getFirestore();

        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
            ).then(resp => {
                 userId = resp.user.uid
                 companyIdFromName = companyName +'-'+ resp.user.uid
                return firestore.collection('users').doc(resp.user.uid).set({
                    name: newUser.name,
                    email: newUser.email,
                    role: newUser.role,
                    company: newUser.company,
                    id: resp.user.uid,
                    companyId: companyIdFromName
            })
           
        }).then(()=>{
            return firestore
            .collection(companyIdFromName)
            .doc("companyOptions")
            .set({
                account: 'free',
                companyUrl: companySlugFromName,
                colors:{                 
                    buttonBgColor:"#69B4A7",
                    buttonColor: "#fff",
                    headerBgColor: "#fff",
                    headerColor: "#666666",
                    menuLeftBgColor: "#69B4A7",
                    menuLeftColor: "#ffffff"
                },
                logo: {
                    companyLogoName: '',
                    companyLogoUrl: ''
                }
             })
        }).then(()=>{
            return firestore
            .collection(companyIdFromName)
            .doc("companyUsers")
            .collection("trainers")
            .doc(userId)
            .set({
                 name: newUser.name,
                 email: newUser.email,
                 role: newUser.role,
                 company: newUser.company,
                 id: userId,
                 companyId: companyIdFromName
            })
        }).then(() => {
            dispatch({ 
                type: SIGN_UP 
            })
        }).catch((error) => {
           
            dispatch({ type: SIGN_UP_ERROR, error})
        });
    }
}

export const resetPassword = (email) => {
    return(dispatch, getState, {getFirebase}) =>{
        const firebase = getFirebase();

        //console.log('RESET PASSWORD AUTH ACTION', email)
        var auth = firebase.auth();
        var emailAddress = email.email

        auth.sendPasswordResetEmail(emailAddress).then(function() {
        // Email sent.
            dispatch({ type: RESET_PASSWORD})
        }).catch(function(error) {
        // An error happened.
            dispatch({ type: RESET_PASSWORD_ERROR, error})

        });
        
    }
}


export const newPassword = (newPasswordData) => {
    return(dispatch, getState, {getFirebase}) =>{
        const firebase = getFirebase();
        var auth = firebase.auth();
        //var emailAddress = newPasswordData.email
        var newPassword = newPasswordData.password
        var actionCode = newPasswordData.actionCode

        
            // Localize the UI to the selected language as determined by the lang
            // parameter.
           // var accountEmail;
            // Verify the password reset code is valid.
            auth.verifyPasswordResetCode(actionCode).then(function(email) {
             // var accountEmail = email;
          
              // TODO: Show the reset screen with the user's email and ask the user for
              // the new password.
          
              // Save the new password.
              auth.confirmPasswordReset(actionCode, newPassword).then(function(resp) {
                // Password reset has been confirmed and new password updated.
                dispatch({ type: NEW_PASSWORD, resp })
                // TODO: Display a link back to the app, or sign-in the user directly
                // if the page belongs to the same domain as the app:
                // auth.signInWithEmailAndPassword(accountEmail, newPassword);
          
                // TODO: If a continue URL is available, display a button which on
                // click redirects the user back to the app via continueUrl with
                // additional state determined from that URL's parameters.
              
              }).catch(function(error) {
                // Error occurred during confirmation. The code might have expired or the
                // password is too weak.
                dispatch({ type: NEW_PASSWORD_ERROR, error})
             
              });
            }).catch(function(error) {
              // Invalid or expired action code. Ask user to try to reset the password
              // again.
              dispatch({ type: NEW_PASSWORD_ERROR, error})
             
            });
          
         
        // auth.sendPasswordResetEmail(emailAddress).then(function() {
        // // Email sent.
        //     dispatch({ type: RESET_PASSWORD})
        // }).catch(function(error) {
        // // An error happened.
        //     dispatch({ type: RESET_PASSWORD_ERROR, error})

        // });
       
    }
}
export const addTrainer  = (newTrainer) => {
    //console.log('ADD TRAINER ACTION', newTrainer)
    return(dispatch, getState, {getFirebase, getFirestore}) => {
        const firebase = getFirebase();
        const functions = firebase.functions();
        const addNewTrainer = functions.httpsCallable('addTrainer');
        addNewTrainer({ email: newTrainer.email, password: newTrainer.password})
        .then((result) => {
            //console.log('ACTION ADD TRAINER RES', result)
        }).then(() => {
            dispatch({ type: ADD_TRAINER, payload: newTrainer});
        })
        .catch(error => {
            dispatch({ type: ADD_TRAINER_ERROR, error });
        });
       
    }
}
// export const addTrainer  = (newTrainer) => {
//     console.log('ADD TRAINER ACTION', newTrainer)
//     return(dispatch, getState, {getFirebase, getFirestore}) => {
//         const firebase = getFirebase();
//         const firestore = getFirestore();
//         var userId;
//         firebase.auth().createUserWithEmailAndPassword(
//             newTrainer.email,
//             newTrainer.password
//             ).then(resp => {
//                  userId = resp.user.uid
                
//                 return firestore.collection('users').doc(resp.user.uid).set({
//                     name: newTrainer.name,
//                     email: newTrainer.email,
//                     role: newTrainer.role,
//                     company: newTrainer.company,
//                     id: userId,
//                     companyId: newTrainer.companyId
//             })
           
//         }).then(()=>{
//             return firestore
//             .collection(newTrainer.companyId)
//             .doc("companyUsers")
//             .collection("traners")
//             .doc(userId)
//             .set({
//                  trainerId: userId,
//                  name: newTrainer.name,
//                  email: newTrainer.email,

//              })
//         }).then(() => {
//             dispatch({ type: ADD_TRAINER, payload: newTrainer});
//           })
//           .catch(error => {
//             dispatch({ type: ADD_TRAINER_ERROR, error });
//           });
//     }
// }